import { api } from '../api';

const paymentsPath = '/payments';

export const getPayments = data =>
  api.post(`${paymentsPath}/filter?page=${data.page}`, data);

export const savePayment = data => api.post(`${paymentsPath}`, data);
